import {Lead} from '../../data/domain/lead';
import {Profile} from '../../data/domain/contact.domain';
import {SessionDTO} from '@minutespourtoi/api-models/dist/models';

export const addDefaultAnimationIfNeeded = async (leadDTO: Lead, sessionDTO: SessionDTO) => {
  if (!leadDTO.myProfile) {
    leadDTO.myProfile = new Profile()
    leadDTO.myProfile.hobbies = []
    leadDTO.myProfile.aboutMe = []
  }
  return leadDTO
}
